// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__JSrYl","message":"NotFound_message__EZC1v"};